module.exports = (__parcel__import__("G142t")).then(() => parcelRequire('8OYBW'));